import classNames from "classnames";
import { useState } from "react";
import { ArrowIcon } from "../../../../../../../shared/icons/ArrowIcon";
import { useAiScoringById } from "../../../../../hook/use-ai-scoring-by-id";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const AiScoringSummary = ({ className }: Props) => {
  const [isSummaryOpen, setIsSummaryOpen] = useState<boolean>(false);
  const { summary } = useAiScoringById();

  const cls = classNames(
    summary?.case_status === "wrong" && styles["case-error"],
    summary?.case_status === "needs_clarification" && styles["case-need-work"],
    summary?.case_status === "ok" && styles["case-valid"],
  );
  const clsContainer = classNames(
    styles["summary-container"],
    summary?.case_status === "wrong" && styles["case-error-container"],
    summary?.case_status === "needs_clarification" &&
      styles["case-need-work-container"],
    summary?.case_status === "ok" && styles["case-valid-container"],
  );

  return (
    <div
      onClick={() => setIsSummaryOpen(!isSummaryOpen)}
      className={clsContainer}
    >
      <div className={styles["brief-wrapper"]}>
        <div className={styles["brief-inner"]}>
          <div className={styles["brief-title"]}>Оценка</div>
          <div className={cls}>
            {summary?.case_status === "wrong"
              ? "Ошибка"
              : summary?.case_status === "needs_clarification"
                ? "Требуется доработка"
                : "Кейс валиден"}
          </div>
          <div className={styles["brief"]}>{summary?.score_short}</div>
        </div>
        <ArrowIcon />
      </div>
      {isSummaryOpen && (
        <div>
          <div className={styles["summary-content"]}>
            {summary?.case_summary}
          </div>
          <div className={styles["summary-content"]}>
            {summary?.chain_coherence}
          </div>
        </div>
      )}
    </div>
  );
};
